import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { updateActionState } from "@/services/tasks";
import { useActionCompletionStore } from "@/stores/action-completion";
/**
 * Completion helpers for a legacy modal channel (old patients view). `complete` marks the
 * linked action-center action done after the legacy letter/form submit succeeds; `clear`
 * drops the link when the modal is cancelled so it can't complete a later, unrelated submit.
 * Both are stable references that read the pending link at call time.
 */
export function useCompleteLegacyAction(channel) {
  var queryClient = useQueryClient();
  var complete = useCallback(function () {
    var _useActionCompletionS = useActionCompletionStore.getState(),
      link = _useActionCompletionS[channel],
      setPending = _useActionCompletionS.setPending;
    if (!link) return;
    var patientUid = link.patientUid,
      reminderId = link.reminderId,
      actionId = link.actionId;
    updateActionState(patientUid, reminderId, actionId, "done").then(function () {
      return queryClient.invalidateQueries(["action-center", patientUid, reminderId]);
    })["catch"](function () {
      return undefined;
    })["finally"](function () {
      return setPending(channel, null);
    });
  }, [channel, queryClient]);
  var clear = useCallback(function () {
    useActionCompletionStore.getState().setPending(channel, null);
  }, [channel]);
  return {
    complete: complete,
    clear: clear
  };
}